import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const requestApi = createApi({
  reducerPath: "requestApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Requests", "Items"],
  endpoints: (builder) => ({
    getCentralRequests: builder.query({
      providesTags: ["Requests"],
      query: ({ page = 1, limit = 10, search = "", status = "ALL", requestedCampusId = "" } = {}) => ({
        url: "/request/central",
        method: "GET",
        params: {
          page,
          limit,
          ...(search && { search }),
          ...(status && { status }),
          ...(requestedCampusId && { requestedCampusId }),
        },
      }),
    }),
    getCampusRequests: builder.query({
      providesTags: ["Requests"],
      query: ({ page = 1, limit = 10, search = "", status = "ALL" } = {}) => ({
        url: "/request/campus",
        method: "GET",
        params: {
          page,
          limit,
          ...(search && { search }),
          ...(status && { status }),
        },
      }),
    }),
    createRequest: builder.mutation({
      query: (payload) => ({
        url: "/request",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Requests"],
    }),
    createCampusRequest: builder.mutation({
      query: (payload) => ({
        url: "/request/campus",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Requests"],
    }),
    updateCampusRequest: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/request/campus/${id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Requests"],
    }),
    vpApprovalRequest: builder.mutation({
      query: (payload) => ({
        url: "/request/vpapproval",
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Requests"],
    }),
    centralApprovalRequest: builder.mutation({
      query: (payload) => ({
        url: "/request/centralapproval",
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Requests"],
    }),
    markRequestReceived: builder.mutation({
      query: (payload) => ({
        url: "/request/markreceived",
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Requests", "Items"],
    }),
    getSingleRequest: builder.query({
      query: (id) => ({
        url: `/request/${id}`,
        method: "GET",
      }),
    }),
    getIssuedStockReport: builder.query({
      providesTags: ["Requests"],
      query: ({
        page = 1,
        limit = 10,
        fromDate,
        toDate,
        requestedCampusId,
        centralCampusInventoryItemId,
        showAll,
      } = {}) => ({
        url: "/request/report",
        method: "GET",
        params: {
          page,
          limit,
          ...(fromDate && { fromDate }),
          ...(toDate && { toDate }),
          ...(requestedCampusId && { requestedCampusId }),
          ...(centralCampusInventoryItemId && { centralCampusInventoryItemId }),
          ...(showAll && { showAll }),
        },
      }),
    }),
  }),
});

export const {
  useGetCentralRequestsQuery,
  useGetCampusRequestsQuery,
  useCreateRequestMutation,
  useCreateCampusRequestMutation,
  useUpdateCampusRequestMutation,
  useVpApprovalRequestMutation,
  useCentralApprovalRequestMutation,
  useMarkRequestReceivedMutation,
  useGetSingleRequestQuery,
  useLazyGetSingleRequestQuery,
  useGetIssuedStockReportQuery,
  useLazyGetIssuedStockReportQuery,
} = requestApi;
